<template>
	<masonry :cols="3" :gutter="20" style="margin-top: 10px">
		<div
			class="call"
			:class="{ assigned: c.assigned }"
			v-for="(c, i) in calls"
			:key="c.id + i"
		>
			<div class="header">
				<img class="avatar" :src="c.client.avatar" v-if="c.client.avatar" />
				<div class="avatar" :src="c.client.avatar" v-else>
					{{ c.client.name.slice(0, 1) }}
				</div>
				<div class="right">
					<div class="name">{{ c.client.surname }} {{ c.client.name }}</div>
					<div class="info" :class="{ assigned: c.assigned }">
						Новый
						<span v-if="c.assigned"
							>&rarr; {{ c.assignedTo.name }}
							{{ c.assignedTo.surname }}</span
						>
						<span v-else>&rarr; ждёт {{ waitTime(c) }}</span>
					</div>
				</div>
			</div>
			<uiButton
				color="light"
				style="margin-top: 10px"
				@click="takeCall(c)"
				v-if="!c.assigned"
			>
				Взять звонок
			</uiButton>
		</div>
	</masonry>
</template>

<script>
import { formatDistanceToNowStrict, differenceInMinutes } from 'date-fns'
import { ru as ruLocale } from 'date-fns/locale'

export default {
	name: 'CallList',
	props: {
		calls: Array,
	},
	computed: {},
	methods: {
		takeCall(e) {
			this.$emit('take', e)
		},
		waitTime(c) {
			let diff = differenceInMinutes(this.$now(), new Date(c.createdAt))
			let unit = 'minute'
			if (diff < 0) unit = 'second'
			return formatDistanceToNowStrict(new Date(c.createdAt), {
				unit: unit,
				locale: ruLocale,
				addSuffix: true,
			}).replace(' назад', '')
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.call {
	margin-bottom: 20px;
	flex-shrink: 0;
	height: fit-content;
	padding: 10px 16px;
	border-radius: 16px;
	border: 1px solid rgba(#000, 0.05);

	&.assigned {
		cursor: pointer;
	}

	.header {
		display: flex;
		align-items: center;
	}

	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 20px;
		background: rgba(0, 0, 0, 0.1);
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: bold;
		color: rgba(0, 0, 0, 0.3);
	}

	.right {
		margin-left: 10px;
	}

	.name {
		font-size: 15px;
		font-weight: bold;
		margin-bottom: 2px;
	}

	.info {
		color: @red;
		font-size: 12px;
		font-weight: bold;

		&.assigned {
			color: @accent;
		}

		span {
			opacity: 0.5;
			color: #000;
			font-weight: normal;
		}
	}

	.text {
		margin: 10px 0;
		font-size: 15px;
		opacity: 0.5;
	}
}
</style>
